import React, { useContext } from 'react';
import {
  parse,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
} from 'date-fns';
import styles from '../../styles/calendar/Calendar.module.scss';
import { CalendarContext } from './CalendarContext';
import { CalendarCell } from '.';
const CalendarCells = ({
  calendarData,
  onDateClick,
  renderCellContent,
  selectedDate,
  setSelectedDate,
}) => {
  const { currentMonth } = useContext(CalendarContext);
  const monthStart = startOfMonth(parse(currentMonth, 'MMM yyyy', new Date()));
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart);
  const endDate = endOfWeek(monthEnd);
  const rows = [];
  let days = [];
  let day = startDate;

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      days.push(
        <CalendarCell
          key={day.toString()}
          day={day}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          monthStart={monthStart}
          onDateClick={onDateClick}
          calendarData={calendarData}
          renderCellContent={renderCellContent}
        />
      );
      day = addDays(day, 1);
    }
    rows.push(
      <div className={styles['temp-row']} key={day.toString()}>
        {days}
      </div>
    );
    days = [];
  }

  return <div className={styles['row-container']}>{rows}</div>;
};

export default CalendarCells;
